import { useTeamMembers } from "@/lib/teamRecordQueries";
import ClientJourneyConfigTab from "@/pages/RehearsalRoom/client360/tabs/JourneyConfigTab";

/**
 * Clients Restructure — Team 360 -> Journey Configuration. The
 * underlying Journey is already Workspace-scoped (ONE definition per
 * Workspace, shared+member tracks together) — never a second Journey
 * engine. `memberId` only selects whose rail the Preview renders;
 * Team 360 defaults it to the first roster member.
 */
export default function TeamJourneyConfigTab({ workspaceId }) {
  const { data, isPending } = useTeamMembers(workspaceId);
  const firstMemberId = (data?.items || [])[0]?.member_id;

  if (isPending) return <p className="text-sm text-ink-soft" data-testid="team-journey-loading">Loading…</p>;
  if (!firstMemberId) return <p className="text-sm text-ink-soft" data-testid="team-journey-no-members">Add a team member first to configure the Journey.</p>;

  return <ClientJourneyConfigTab workspaceId={workspaceId} memberId={firstMemberId} />;
}
